<script setup>
import { usePage } from "@inertiajs/vue3";

const appBaseUrl = usePage().props.appBaseUrl;
</script>

<template>
    <div class="min-vh-100 d-flex flex-lg-row flex-column-reverse">
        <div
            id="left-container"
            class="d-flex justify-content-center mx-3 mx-lg-0"
        >
            <div class="my-lg-auto row justify-content-center flex-grow-1">
                <div class="col-12 col-md-8">
                    <div class="text-center mb-5">
                        <div
                            class="circle-wrapper mx-auto d-flex justify-content-center"
                        >
                            <img
                                id="logo"
                                :src="
                                    appBaseUrl +
                                    '/assets/images/Coat_of_arms_of_Sabah.jpg'
                                "
                                class="me-3"
                                alt="STB Logo"
                            />
                            <img
                                id="logo"
                                :src="
                                    appBaseUrl + '/assets/images/stb-logo.jpg'
                                "
                                class=""
                                alt="STB Logo"
                            />
                        </div>
                        <div id="logo-title" class="text-center"></div>
                    </div>

                    <slot />
                </div>
            </div>
        </div>

        <div id="right-container" class="d-flex flex-column">
            <div class="overlay d-flex align-items-center">
                <div class="row w-100 justify-content-center">
                    <div class="col-10">
                        <div class="d-none d-lg-block">
                            <div class="logo-feel-sabah text-center">
                                <img
                                    src="/assets/images/feel-sabah.svg"
                                    alt="logo-feel-sabah"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style>
#left-container {
    flex-grow: 2;
    margin-top: -50px;
    z-index: 2;
}

@media only screen and (min-width: 1000px) {
    #left-container {
        min-width: 562px;
    }
}

#logo {
    height: 160px;
}

.circle-wrapper {
    border-radius: 19px;
    height: 130px;
    width: 270px;
    background: white;
}

#left-container #logo-title {
    font-weight: bold;
}

#right-container {
    background-image: url("/assets/images/kinabatangan-4.jpg");
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    flex-grow: 3;
    min-height: 200px;
    z-index: 0;
}

#right-container .overlay {
    background: linear-gradient(
        360deg,
        rgba(255, 255, 255, 0.8) 0%,
        rgba(255, 255, 255, 0) 122.37%
    );
    flex-grow: 1;
}

#right-container h3 {
    font-size: 3rem;
    line-height: 3.8rem;
    color: #282828;
    font-weight: 900;
    z-index: 100;
}

#right-container .logo-feel-sabah {
    z-index: 100;
}

#right-container .logo-feel-sabah img {
    width: 90%;
    max-height: 200px;
}

#right-container h4 {
    margin-left: 100px;
    font-size: 2rem;
    line-height: 2.8rem;
    color: #fff;
    z-index: 100;
}
</style>
